(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const heroSwiper = new Swiper('.hero-swiper', {
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination-hero',
      clickable: true,
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
